// extracted by mini-css-extract-plugin
export default {"wrapper":"UnavailablePreview-module__wrapper--b2dfa","hint":"UnavailablePreview-module__hint--c8b35"};